import { daysBetween } from '../measurement/window-mechanics';
import { CONFIRMATION_WINDOW_DAYS } from './constants';

/** True when more than CONFIRMATION_WINDOW_DAYS have passed since the cut's first discount day, so the price has not come back and `date` restarts the window (CONTEXT.md, Campaign run). */
export function restartsOn(cutStart: string, date: string): boolean {
  return daysBetween(cutStart, date) > CONFIRMATION_WINDOW_DAYS;
}

/** True while `date` is within CONFIRMATION_WINDOW_DAYS after the run's end, the days a return is looked for (CONTEXT.md, Confirmed campaign). */
export function withinReturnWindow(endDate: string, date: string): boolean {
  return daysBetween(endDate, date) <= CONFIRMATION_WINDOW_DAYS;
}

/** True when CONFIRMATION_WINDOW_DAYS or more have passed since the run's end as of `asOf` (CONTEXT.md, Confirmed campaign). */
export function returnWindowElapsed(endDate: string, asOf: string): boolean {
  return daysBetween(endDate, asOf) >= CONFIRMATION_WINDOW_DAYS;
}
